import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MdSnackBar } from '@angular/material';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'exception-form',
  providers: [StorageService],
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class ExceptionFormComponent implements OnInit {

  action: string;
  exceptionCode: string;
  exceptionType: string;
  exception: any = {};

  exceptions: string[] = [];
  filteredExceptions: string[];
  chipAddition: boolean = true;
  chipRemoval: boolean = true;

  private storage: any = null;
  private order: any = null;
  private mogid: string;
  storages: any[];
 
  constructor(private _storageService: StorageService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _snackBarService: MdSnackBar,
              private _loadingService: TdLoadingService,
              private _dialogService: TdDialogService) {}

  goBack(): void {
    this._router.navigate(['/exception']);
  }

  ngOnInit(): void {
    this._route.url.subscribe((url: any) => {
      this.action = (url.length > 1 ? url[1].path : 'add');
    });
    this._route.params.subscribe((params: {exceptionType: string, exceptionCode: string}) => {
      this.exceptionCode = params.exceptionCode;
      this.exceptionType = params.exceptionType;
      if (this.exceptionCode && this.exceptionType) {
        this.load();
      } else {
        this.exceptions = [];
      }
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('exception.form');
      this.exception = await this._storageService.getException(this.exceptionCode).toPromise();
      if (this.exceptionType == 'MISSING_ONLINE_RETURN') {
        this.loadParcel(this.exceptionCode);
      }
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error loading the exception'});
    } finally {
      this._loadingService.resolve('exception.form');
    }
  }

  async save(): Promise<void> {
    try {
      this._loadingService.register('exception.form');    
      let exception = {
        reference : this.exception.reference,
        code : this.exception.code,
        exceptionDate : new Date(),
        exceptionType : this.exception.exceptionType,
        exceptionStatus : 'OPEN',
        containerName : this.exception.containerName
    }
      await this._storageService.sendToException(exception).toPromise();
      this._snackBarService.open('Exception saved', 'Ok');
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({title: 'There was an error saving the exception', message: error.message});
    } finally {
      this._loadingService.resolve('exception.form');
    }
  }

  // For missing_online_return cases
  async loadParcel(exceptionCode: string): Promise<void> {
    try {
      await this.getParcel(exceptionCode);
      if (this.storage) { 
        await this.getParcelDetails(this.storage.businessKey);
      }
    } catch (error) {
    } finally {
    }
  }

  async getParcel(reference: string): Promise<void> {
    try{
        this.storages = await this._storageService.getParcel(reference).toPromise();
        if (this.storages.length == 0) {
            this.storage = null;
        } else {
            this.storage = this.storages[0];
        }
    } catch (error) {
        console.log('Cannot get parcel!');
        this.storage = null;
    } finally {
    }
  }

  async getParcelDetails(businessKey: string): Promise<void> {
    try{
        let orderList = await this._storageService.getDetailsByBusinessKeyReader(businessKey).toPromise();
        if (orderList) {this.order = orderList[0];}
        if (this.order) {
            this.mogid = this.order.mogid;
        }
        
    } catch (error) {
        console.log('Cannot get order details!');
        this.storage = null;
    } finally {
    }
  }

  async saveArticles() {
    this.storage.containerName = this.exception.containerName;
    await this._storageService.updateStorage(this.storage, 'UPDATE_WAREHOUSEITEM').toPromise();
    //resolve exception
    await this._storageService.resolveException(this.exception.code, null).toPromise();
    //goBack() or return to exception list
    this._router.navigate(['/exception']);
  }

  cancelArticles(articles: any) {
    //this.articles = articles;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/exception/form/form.component.ts